import { Component, OnInit } from '@angular/core';
import { EmpresaService } from '../../servicios/empresa.service';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
declare var jQuery: any;

@Component({
    selector: 'empresas',
    templateUrl: 'empresas.template.html'
})

export class EmpresasComponent implements OnInit {

    constructor(
        private empresaService: EmpresaService,
        private alertService: AlertService,
        private tipoServicioService: TipoServicioService
    ) {

    }

    ngOnInit() {
        this.getTipoServicios();
        this.getEmpresas();
    }

    public filter  = "";
    public empresa = {
        nit:"",
        nombre:"",
        estado:"",
        idTipoServicio:""
    };
    public empresas = [];
    public tipoServicios = [];
    public update = false;
    files: FileList;
    
    getEmpresas() {
        loading_show();
        this.empresaService.getAll((data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.empresas = data.Content;
            }

        });
    }

    getTipoServicios(){
        loading_show();
        this.tipoServicioService.getAll((data: Result) => {
            loading_hide();
            
            if (data.isOk) {
                this.tipoServicios = data.Content;
            }

        });
    }

    getFiles(event: any) {
        this.files = event.target.files;
        for (var i = 0, f; f = this.files[i]; i++) {
            if (!f.type.match('image.*')) {
                continue;
            }
            var reader = new FileReader();
            reader.onload = (function (theFile) {
                return function (e) {
                    document.getElementById("image").innerHTML = ['<img class="animated bounceIn" style="width:60%; margin-left:20%" src="', e.target.result, '" />'].join('');
                };
            })(f);
            reader.readAsDataURL(f);
        }
    }

    saveEmpresa() {
        //let formData: FormData = new FormData();

        /*if (!this.files) {
            this.alertService.warning('por favor cargar logo del empresa');
            return;
        }*/

        if (!this.empresa['estado']) {
            this.empresa['estado'] = 'ACTIVO';
        }

        //formData.append('imagen', this.files[0]);


        var object = {
            'nombre': this.empresa['nombre'],
            'nit': this.empresa['nit'],
            'idTipoServicio':this.empresa['idTipoServicio'],
            'estado': this.empresa['estado'],
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.empresaService.save(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {
                this.getEmpresas();
                this.empresa = this.empresas[0];
                this.alertService.success(data.Mensaje);
            }
        });

    }

    showempresa(empresa: any) {
        this.empresa = empresa;
        this.update = true;
        jQuery("#t1").addClass("active");
        jQuery("#t2").removeClass("active");
        jQuery("#tab-1").addClass("active");
        jQuery("#tab-2").removeClass("active");
    }


    cancel() {
        this.empresa = this.empresas[0];
        this.update = false;
        document.getElementById("image").innerHTML = '<div class="row">' +
            '<div class="col-lg-12" style="text-align: center;">' +
            '<i class="fa fa-image ico-bg"></i>' +
            '</div>' +
            '</div>';
    }

    updateempresa() {
        /*let formData: FormData = new FormData();

        if (this.files) {
            formData.append('imagen', this.files[0]);
        }*/


        if (!this.empresa['estado']) {
            this.empresa['estado'] = 'ACTIVO';
        }


        var object = {
            'id': this.empresa['id'],
            'nombre': this.empresa['nombre'],
            'nit': this.empresa['nit'],
            'idTipoServicio':this.empresa['idTipoServicio'],
            'estado': this.empresa['estado'],
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.empresaService.update(object, (data: Result) => {
            loading_hide();
            console.log(data)
            if (data.isOk) {
                this.update = false;
                this.getEmpresas();
                this.empresa = {
                    nit:"",
                    nombre:"",
                    estado:"",
                    idTipoServicio:""
                };
                this.alertService.success(data.Mensaje);

            }
        });
    }


    updateState(id: number, state: string) {
        loading_show();
        var object = {
            'id': id,
            'estado': state
        }

        this.empresaService.updateState(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Estado actualizado");
                this.getEmpresas();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/views/empresas/empresas.component.ts